import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PlanningGraphsHierarchicalPlanning = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Planning graphs, Hierarchical Planning"
    videos={[
      "https://www.youtube.com/embed/esf7m1H4Em0",
      "https://www.youtube.com/embed/JGrU9Bcf4wA"
    ]}
    takeaways={[]}
    questions={[
      "Discuss how the hierarchical planning helps to reduce the size of the search space with a suitable example.",
      "Explain how hierarchical task network (HTN) planning can be applied in non-deterministic domains. Provide examples to illustrate how HTN planning manages uncertainty and unpredictable outcomes."
    ]}
    exampleVideos={[]}
  />
);
}

export default PlanningGraphsHierarchicalPlanning;
